export type Veiculacao =
  | "Instagram Feed"
  | "Instagram Stories"
  | "Instagram Reels"
  | "TikTok"
  | "YouTube Shorts"
  | "Anúncio Meta Ads"
  | "Anúncio Google/YouTube"
  | "Outro";

export const VEICULACAO_OPTIONS: Veiculacao[] = [
  "Instagram Feed",
  "Instagram Stories",
  "Instagram Reels",
  "TikTok",
  "YouTube Shorts",
  "Anúncio Meta Ads",
  "Anúncio Google/YouTube",
  "Outro",
];

export type CriativoStage =
  | "idle"
  | "preparing"
  | "extracting-audio"
  | "transcribing"
  | "analyzing"
  | "done"
  | "error";

export interface CriativoAnalysis {
  objetivo_detectado?: string;
  objetivo_confianca?: "alta" | "media" | "baixa";
  tipo_conteudo?: string;
  score_geral?: number;
  pontos_fortes?: string[];
  pontos_fracos?: string[];
  sugestoes?: string[];
  riscos_compliance?: string[];
  hook_analise?: string;
  cta_analise?: string;
  legenda_sugerida?: string;
  resumo_executivo?: string;
  raw_text?: string;
  parse_error?: boolean;
}

export interface AnalyzeCreativeInput {
  file: File;
  veiculacao: Veiculacao;
  objetivo?: string;
  label?: string;
  /** Optional pre-made transcript. When provided, skips audio extraction + Whisper. */
  transcriptText?: string;
}

export interface AnalyzeCreativeResult {
  jobId: string;
  criativoId: string;
  transcript: string;
  analysis: CriativoAnalysis;
}

export interface CriativoRow {
  id: string;
  label: string;
  media_kind: "image" | "video";
  veiculacao: string;
  objetivo_input: string | null;
  objetivo_detectado: string | null;
  transcript_text: string | null;
  analysis_payload: CriativoAnalysis | null;
  ai_job_id: string | null;
  created_at: string;
  updated_at: string;
}
